import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import service from "../Profiles/service";

const EditProfiles = () => {
  // eslint-disable-next-line no-unused-vars
  const [profile, setProfile] = useState();
  const updateProfileClickHandler = (profile) => {
    service.updateProfile(profile)
    .then(profile => setProfile(profile));
  }

  const [profiles, setProfiles] = useState([]);
  useEffect(() =>
    service.findAllProfiles()
    .then(profiles => setProfiles(profiles)));

  const history = useHistory()

  return(
    <div>
      <h4>
        <button className={"btn fas fa-times"}
                onClick={() => {history.goBack()}}></button>
        Edit profile</h4>
      <ul className="list-group">
        {
          profiles.map((profile)=>
              <li>
                <button className = "btn btn-secondary rounded-pill float-end me-5 mt-3" onClick={(eventprofile) => {updateProfileClickHandler(profile)}}>
                  Save
                </button>
                <h6 className={"text-secondary"}>{profile.save} Tweets</h6>
                <img style={{display: "flex"}}
                     src={profile.bannerPicture}
                     alt={"banner"}
                     width="100%"
                     height="200px"/>
                <img className="rounded-circle wd-avatar-image"
                     style={{width: '144px', float: "top", marginTop: "-8%", position: "relative", zIndex: 1}}
                     alt={"avatar"}
                     src={profile.profilePicture}/>

                <form className="form-floating">
                  <input type="name" className="form-control bg-transparent text-white" id="firstName"
                         onChange={e => {profile.firstName = e.target.value; return updateProfileClickHandler(profile);}}
                         placeholder="first name" defaultValue={profile.firstName}/>
                  <label>First Name</label>
                </form>
                <form className="form-floating">
                  <input type="name" className="form-control bg-transparent text-white" id="lastName"
                         onChange={e => {profile.lastName = e.target.value; return updateProfileClickHandler(profile);}}
                         placeholder="last name" defaultValue={profile.lastName}/>
                  <label>Last Name</label>
                </form>
                <form className="form-floating">
                  <input type="bio" className="form-control bg-transparent text-white" id="bio"
                         onChange={e => {profile.bio = e.target.value; return updateProfileClickHandler(profile);}}
                         placeholder="who am I" defaultValue={profile.bio}/>
                  <label>Bio</label>
                </form>
                <form className="form-floating">
                  <input type="location" className="form-control bg-transparent text-white" id="location"
                         onChange={e => {profile.location = e.target.value; return updateProfileClickHandler(profile);}}
                         placeholder="my location" defaultValue={profile.location}/>
                  <label>Location</label>
                </form>
                <form className="form-floating">
                  <input type="website" className="form-control bg-transparent text-white" id="website"
                         onChange={e => {profile.website = e.target.value; updateProfileClickHandler(profile);}}
                         placeholder="my site" defaultValue={profile.website}/>
                  <label>Website</label>
                </form>

                <h6 className={"ms-3 text-secondary"}>Birth date<a href={'#top'} className="btn text-primary">Edit</a></h6>
                <a href={'#top'} className={"text-white text-decoration-none ms-3"}>{profile.dateOfBirth}</a>
              </li>
          )
        }
      </ul>
    </div>
  );

};
export default EditProfiles;
